import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";

import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/SiteImprove";
import InfoWarningText from "../InfoWarningText";
import { ReduxState } from "../infrastructure/redux/state";
import { useTranslate } from "../infrastructure/useTranslate";

export const Bedrift: FC = () => {
  const params = useSelector((state: ReduxState) => state.app.params);

  const erSigneringsFlyt = params.mode === "signering";
  const erBehandlerFlyt = params.mode === "behandler";

  const translate = useTranslate();

  const location = useLocation();

  useEffect(() => {
    document.title = `Digipost - ${translate(
      erBehandlerFlyt
        ? "register.org.intro.header_integrationpartner"
        : "register.org.intro.header",
    )}`;

    if (erSigneringsFlyt) {
      siteImproveEvent({
        category: SiteImproveCategories.SIGNERING_VIRKSOMHET,
        action: SiteImproveActions.FROM_SIGNERING,
      });
    }
  }, [erBehandlerFlyt, erSigneringsFlyt, translate]);

  const userLoggedout = location.search.indexOf("logout") > -1;

  if (userLoggedout) {
    return <InfoWarningText textkey="register.error.logged_out" />;
  }

  return <Outlet />;
};
